import { type ForwardedRef, forwardRef } from 'react';
import { Grid, GridColProps, GridProps } from '@mantine/core';

import classes from './Grid.module.css';

interface MercuryGridProps extends GridProps {
  removePadding?: boolean;
}

export const MercuryGrid = ({
  columns,
  removePadding,
  children,
  id,
  gutter = 25,
}: MercuryGridProps) => (
  <Grid
    columns={columns}
    gutter={gutter}
    id={id}
    classNames={{
      root: `
      ${classes.root}
      mercury__grid
      ${removePadding ? classes.removePadding : ''}
      `,
    }}
  >
    {children}
  </Grid>
);

interface MercuryColProps extends GridColProps {
  transparent?: boolean;
  fullWidth?: boolean;
  'data-testid'?: string;
}

export const MercuryCol = forwardRef<HTMLDivElement, MercuryColProps>(
  (
    { children, transparent, fullWidth, 'data-testid': dataTestId, ...colProps }: MercuryColProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <Grid.Col {...colProps} ref={ref}>
      <div
        data-testid={dataTestId}
        className={`${classes.col} mercury__grid-item-inner
      ${transparent ? classes.transparent : ''}
      ${fullWidth ? classes.fullWidth : ''}
      `}
      >
        {children}
      </div>
    </Grid.Col>
  )
);
